import $ from "jquery";
import Sniffer from 'snifferjs';

export default class Cursor {
    constructor() {
        this.cursor = {
            pointer: document.getElementById('cursor'),
        };
    }

    init() {
        if(Sniff.features.mobile){
            this.cursor.pointer.remove();
        } else {
            this.followCursor();
        }
    }

    followCursor() {
        let root = document.documentElement;
        const cursor = document.getElementById('cursor');
        var links = $('a, button, input, textarea, [data-label]');

        document.addEventListener('mousemove', function(e){
            cursor.style.left = e.pageX + 'px';
            cursor.style.top = e.pageY + 'px';
            // cursor.css({
            //     left: e.pageX + 'px',
            //     top: e.pageY + 'px',
            // });
        });

        links.each(function(){
            $(this).on('mouseover',function(){
                $('#cursor').addClass('hovering');
                if($(this).data('label')){
                    $('#cursor').attr('data-label',$(this).data('label'));
                }
            });
            $(this).on('mouseleave',function(){
                $('#cursor').removeClass('hovering');
                if($(this).data('label')){
                    // setTimeout(function(){
                        $('#cursor').attr('data-label',$('#cursor').data('label-default'));
                    // },1000)
                }
            });
        });
    }
}
